module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-nav--items"
  }, [_c('div', {
    staticClass: "main-nav--row grid--row"
  }, [_vm._l((_vm.root.children), function(child, idx) {
    return _c('cmp-main-nav-item', {
      key: idx,
      staticClass: "main-nav--col grid--col",
      attrs: {
        "facet": _vm.facet,
        "child": child,
        "is-fixed": _vm.isFixed,
        "idx": idx,
        "level": 0
      }
    }, [_c('span', {
      staticClass: "main-nav--text",
      attrs: {
        "slot": "link"
      },
      domProps: {
        "innerHTML": _vm._s(child.label)
      },
      slot: "link"
    })])
  }), _vm._v(" "), _c('cmp-main-nav-item', {
    staticClass: "main-nav--col grid--col",
    attrs: {
      "facet": _vm.facet,
      "child": _vm.root,
      "is-fixed": _vm.isFixed,
      "show-sub-nav": false,
      "level": 0
    }
  }, [_c('img', {
    staticClass: "u-reset main-nav--logo",
    attrs: {
      "slot": "link",
      "src": _vm.logoUrl,
      "alt": _vm.root.label
    },
    slot: "link"
  })])], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a991d592", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a991d592","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/main-nav/main-nav-items-partial/index.vue
// module id = 578
// module chunks = 7